<template lang="pug">
  section.details.bg-xl-blue.wrapper-p
    header.details__header
      h2.details__heading.t-h2 ЕвроМобайл — инжиниринг в деталях:

    .details__content
      base-list(:elements="list.items")
</template>

<script>
export default {
  data () {
    return {
      list: {
        items: [{
          class: `details__list-item`,
          text: `Обладаем богатым опытом в установке и эксплуатации систем бортового оборудования`
        }, {
          class: `details__list-item`,
          text: `Снимаем дополнительные заботы эксплуатирующим предприятиям и производителям техники`
        }, {
          class: `details__list-item`,
          text: `Делаем комфорт пассажиров лёгким в обслуживании`
        }, {
          class: `details__list-item`,
          text: `Снимаем негативное отношение перевозчиков к большому парку оборудования на ТС`
        }, {
          class: `details__list-item`,
          text: `Cоздаём и поддерживаем различные версии продукта, подключаем дополнительные системы, реализовываем модульную структуру оборудования.`
        }]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .details {
    display: flex;
    padding-top: 6.3vw;
    padding-bottom: 9.11vw;

    @include respond-max(tablet) {
      flex-direction: column;
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }

  .details__header {
    flex-shrink: 0;
    width: 48.5vw;
    padding-right: 18%;

    @include respond-max(tablet) {
      width: 100%;
      margin-bottom: 2rem;
      padding-right: 0;
    }
  }

  /deep/.details__list-item {
    border-color: rgba($text-color, 0.2);

    &:last-of-type {
      border-color: rgba($text-color, 0.2);
    }
  }
</style>
